import call from "../../../../service/http";
import BioConstants from "./BioConstants";

export default {
  state: {
    bio: [],
  },
  mutations: {
    SET_BIO: (state, payload) => {
      state.bio = payload;
    },
  },
  getters: {
    bio: (state) => state.bio,
  },
  actions: {
    getBio: ({ commit }) => {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true, { root: true });
      call("get", BioConstants.bio)
        .then((res) => {
          commit("SET_BIO", res.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    saveBio: ({ commit, dispatch }, data) => {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true, { root: true });
      call("post", BioConstants.bio, data)
        .then(() => {
          dispatch("Auth/user", null, { root: true });
          dispatch("getBio");
          Event.$emit("application-checklist");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    updateBio: ({ commit, dispatch }, data) => {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true, { root: true });
      call("post", BioConstants.update, data)
        .then(() => {
          dispatch("getBio");
          dispatch("Auth/user", null, { root: true });
          Event.$emit("application-checklist");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },
  },
};
